import { databaseViewFilterFunctions } from '@streamlain/database-identity';

import { t } from '../../logical/type-presets.js';
import { createFilter } from './create.js';

export const unknownFilter = [
  createFilter({
    name: 'isNotEmpty',
    self: t.unknown.instance(),
    args: [] as const,
    label: 'Is not empty',
    shortString: () => ': Is not empty',
    impl: databaseViewFilterFunctions.isNotEmpty,
  }),
  createFilter({
    name: 'isEmpty',
    self: t.unknown.instance(),
    args: [] as const,
    label: 'Is empty',
    shortString: () => ': Is empty',
    impl: databaseViewFilterFunctions.isEmpty,
  }),
];
